import { useCurrentPhenoQuery } from "@/query/pheno-query";
import { Icon } from "./icon";

const PhenoWidget: React.FC<{ type: string }> = ({ type }) => {
  const { data: pheno, isLoading } = useCurrentPhenoQuery(type);

  return (
    <div className="absolute top-24 right-10 z-10 py-5 px-10 rounded-3xl bg-gradient-to-b from-blue-100 via-[#2a4b85] via-50% to-[#083072] to-90% text-white">
      {!pheno && isLoading && <div>Түр хүлээнэ үү...</div>}
      {pheno && (
        <>
          <div className="text-4xl text-center font-bold uppercase drop-shadow drop-shadow-black">
            {type == "darkhan"
              ? "Дархан"
              : type == "erdenet"
              ? "Эрдэнэт"
              : "Улаанбаатар"}
          </div>
          <div className="flex justify-between items-center mt-4">
            <Icon
              name="cloudly.svg"
              alt="day"
              className="-ml-20 -mt-5 -mb-14"
            />
            <span className="font-bold text-6xl">{pheno.temp_day}°C</span>
          </div>
          <div className="flex justify-between items-center mt-4">
            <Icon
              name="night.svg"
              alt="night"
              className="-ml-20 -mt-5 -mb-14"
            />
            <span className="font-bold text-6xl">{pheno.temp_night}°C</span>
          </div>
          <div className="flex justify-between items-center mt-4">
            <div className="flex font-bold text-3xl gap-4 uppercase w-48">
              <Icon name="wind2.svg" alt="wind" />
              <span>Салхи</span>
            </div>
            <div className="border-l border-white h-6"></div>
            <div className="flex-1 flex font-bold text-3xl justify-end">
              <span>{pheno.wind_day}</span>
              <span className="ml-1 font-medium text-xl mt-2">M/C</span>
            </div>
          </div>
          <div className="flex justify-between items-center mt-4">
            <div className="flex font-bold text-3xl gap-4 uppercase w-48">
              <Icon name="humidity.svg" alt="rain" />
              <span>Чийг</span>
            </div>
            <div className="border-l border-white h-6"></div>
            <div className="flex-1 flex font-bold text-3xl justify-end">
              <span>{pheno.rain_day_chance}</span>
              <span className="ml-1 font-medium text-xl mt-2">%</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default PhenoWidget;
